import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "./api";

// Cookie-less session id — stored in sessionStorage so each browser tab session counts once
function getSessionId() {
  let s = sessionStorage.getItem("ixirli_ss");
  if (!s) {
    s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("ixirli_ss", s);
  }
  return s;
}

export default function useAnalytics() {
  const location = useLocation();
  const lastPath = useRef("");

  useEffect(() => {
    // Skip admin pages
    if (location.pathname.startsWith("/admin")) return;
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;

    // Fire-and-forget; ignore errors
    api
      .post("/analytics/track", {
        session_id: getSessionId(),
        path: location.pathname,
        referrer: document.referrer || "",
        lang: localStorage.getItem("ixirli_lang") || "tr",
        screen_w: window.innerWidth,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      })
      .catch(() => {});
  }, [location.pathname]);
}
